import { IntegrationConnection } from '@aibees/elephant/types/integration';

export function useIntegrationDefaultItem(
  integrationConnections?: IntegrationConnection[]
) {
  return integrationConnections?.find((x) => x.primary);
}
